import { useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import { isPublicPath } from "./routing";

const ScrollEffect = ({ location }) => {
  const prevLocation = usePrevious(location);

  if (isLocationChanged(location, prevLocation) || isPublicPath() || shdScrollTop(location)) {
    window.scrollTo(0, 0);
  }
  return null;
};

// a hook for finding previous prop value in useEffect()
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const baseUrl = (path) => (path ? path.split("/")[1] : null);
const isLocationChanged = (location, prevLocation) =>
  baseUrl(location.pathname) !== baseUrl(prevLocation && prevLocation.pathname);
const shdScrollTop = (location) => ["Disclaimers"].includes(baseUrl(location.pathname));

export const ScrollToTop = withRouter(ScrollEffect);
